import { IconButton as e } from "../Button/IconButton.mjs";
import { RemoveSlot as t, StyledChip as n } from "./styled/Chip.styled.mjs";
import "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { X as a } from "lucide-react";
//#region src/components/Chip/Chip.tsx
var o = ({ children: o, icon: s, onRemove: c, removeLabel: l, className: u }) => /* @__PURE__ */ i(n, {
	className: u,
	children: [
		s && /* @__PURE__ */ r(s, {
			size: 12,
			strokeWidth: 2
		}),
		o,
		c && /* @__PURE__ */ r(t, { children: /* @__PURE__ */ r(e, {
			type: "button",
			size: "sm",
			variant: "ghost",
			label: l,
			icon: /* @__PURE__ */ r(a, { size: 12 }),
			onClick: c
		}) })
	]
});
//#endregion
export { o as Chip };
